import { CKEditor } from "@ckeditor/ckeditor5-react";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import React from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import { useHistory, useParams } from "react-router";
import * as yup from "yup";
import UploadImage from "../../UploadImage";
import Editor from "ckeditor5-custom-build";
import editorConfiguration from "../../../../util/EditorConfiguration";
import apiHelper from "../../../../util/ApiHelper";
import {
  Autocomplete,
  ToggleButton,
  ToggleButtonGroup,
} from "@material-ui/lab";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { modal } from "../../../../util";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: 0,
  },
  buttonGroup: {
    marginTop: "20px",
    textAlign: "right",
    "& button": {
      fontSize: "13px",
      textTransform: "inherit",
      color: "#306F9D",
    },
  },
  innerBox: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
    background: "#ffffff",
  },
  input: {
    width: "100%",
    marginTop: "20px",
    marginLeft: "10px",
    "& button": {
      fontSize: "13px",
      lineHeight: "15px",
      width: "25%",
    },
  },
  select: {
    "& .MuiOutlinedInput-input": {
      padding: "12px 10px",
      fontSize: "13px",
      color: "#333333",
    },
    ".MuiInputLabel-outlined": {
      transform: "translate(14px, 15px) scale(1)!",
    },
    marginBottom: "20px",
  },
}));

const schema = yup.object().shape({
  filmScreenings: yup.array().of(
    yup.object().shape({
      venue: yup.string().required("Required"),
    })
  ),
});

const defaultValues = {
  image: "",
  localizations: {
    en: {
      name: "",
      description: "",
      comment: "",
    },
    tc: {
      name: "",
      description: "",
      comment: "",
    },
  },
  categoryIds: [],
  status: "ACTIVE",
};

export default function AwardDetailPage(props) {
  const { match } = props;
  const history = useHistory();
  const { id } = useParams();
  const classes = useStyles();
  const [categories, setCategories] = React.useState([]);

  const { control, handleSubmit, getValues, setValue, reset, formState } =
    useForm({
      defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
      resolver: yupResolver(schema),
    });

  React.useEffect(() => {
    getAwardCategory();
  }, []);

  React.useEffect(() => {
    if (id) {
      apiHelper.hkiff
        .getAward(id)
        .then((response) => {
          reset(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, []);

  const getAwardCategory = React.useCallback(async () => {
    try {
      const result = await apiHelper.hkiff.getAwardCategory(
        null,
        null,
        null,
        null,
        null,
        null,
        true
      );
      setCategories(result.data.content.filter((x) => x));
    } catch (err) {
      console.log(err);
    }
  }, []);

  const updateAward = async (data) => {
    try {
      const result = await apiHelper.hkiff.updateAward(id, {
        ...data,
        updateTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
      });
      console.log(result.data);
      toast.dark("Your changes is saved.");
      history.push("/hkiff/awards/list");
    } catch (err) {
      console.log(err);
    }
  };

  const createAward = async (data) => {
    try {
      await apiHelper.hkiff.createAward(data);
      toast.dark("Award created.");
      //clear all fields
      reset(defaultValues);
    } catch (err) {
      console.log(err);
    }
  };

  const onSubmit = (data) => {
    const sendSponsorCategory = () => {
      const req = data;
      if (id) {
        updateAward(req);
      } else {
        createAward(req);
      }
    };
    sendSponsorCategory();
  };

  const deleteAward = async (id) => {
    const decision = await modal.fire({
      title: "Delete Award",
      text: "Are you sure to delete this award?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        const result = await apiHelper.hkiff.deleteAward(id);
        if (result.status === 200) {
          toast.dark("Award deleted.");
          history.push("/hkiff/awards/list");
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const categoryIds = useWatch({ control, name: "categoryIds" });

  return (
    <div className={classes.content}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Typography variant="h4" gutterBottom>
          Film > {id ? "Edit Award" : "Create Award"}
        </Typography>
        <Grid container>
          <Typography variant="h6" gutterBottom>
            {id ? "Edit Award" : "Create Award"}
          </Typography>
          <Grid item xs={12}>
            <Controller
              name="localizations.en.name"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  label="Title (English)"
                  variant="outlined"
                  margin="dense"
                  className={classes.textInput}
                  fullWidth
                  {...field}
                  error={!!error}
                  helperText={
                    error
                      ? error.message
                      : "The name is how it appears on your site."
                  }
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="localizations.tc.name"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  label="Title (Traditional Chinese)"
                  variant="outlined"
                  margin="dense"
                  className={classes.textInput}
                  fullWidth
                  {...field}
                  error={!!error}
                  helperText={
                    error
                      ? error.message
                      : "The name is how it appears on your site."
                  }
                />
              )}
            />
          </Grid>
          <Grid item xs={12} container alignItems="center">
            <FormControl
              fullWidth
              variant="outlined"
              style={{ margin: "0 4px" }}
            >
              <Controller
                name={`categoryIds`}
                control={control}
                render={({
                  field: { onChange, value, ...rest },
                  fieldState: { error },
                }) => (
                  <Autocomplete
                    multiple
                    fullWidth
                    label="Category"
                    options={categories}
                    // disabled={disabled}
                    getOptionSelected={(option, value) =>
                      option.id === value.id
                    }
                    getOptionLabel={(option) => option.localizations.en.name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Category"
                        margin="dense"
                        placeholder="Category"
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                    value={categories.filter((o) =>
                      categoryIds?.includes(o.id)
                    )}
                    onChange={(e, values) => {
                      setValue(
                        `categoryIds`,
                        values.map((item) => item.id)
                      );
                    }}
                    {...rest}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <UploadImage
              name={`image`}
              // data={data}
              data={{
                localizations: { en: { image: null } },
              }}
              embeddedName="image"
              control={control}
              Controller={Controller}
              setValue={setValue}
              getValues={getValues}
              // disabled={disabled}
              uploadLabel="Upload Thumbnail Image"
              changeLabel="Change Thumbnail Image"
              uploadFolder="AWARD"
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="localizations.en.description"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  label="Description (English)"
                  variant="outlined"
                  margin="dense"
                  className={classes.textInput}
                  fullWidth
                  {...field}
                  error={!!error}
                  helperText={error ? error.message : ""}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="localizations.tc.description"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  label="Description (Traditional Chinese)"
                  variant="outlined"
                  margin="dense"
                  className={classes.textInput}
                  fullWidth
                  {...field}
                  error={!!error}
                  helperText={error ? error.message : ""}
                />
              )}
            />
          </Grid>
          <Grid item direction="vertical" spacing={3} xs={12}>
            <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
              <Typography variant="p">Comment (English)</Typography>
            </Box>
            <Grid item xs={12}>
              <Controller
                name="localizations.en.comment"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <CKEditor
                    editor={Editor}
                    config={editorConfiguration}
                    data={field.value}
                    // disabled={disabled}
                    onReady={(editor) => {
                      // You can store the "editor" and use when it is needed.
                      console.log("Editor is ready to use!", editor);
                      // editor.setData(initialValues.terms.valueEn);
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      field.onChange(data);
                      // console.log({ event, editor, data });
                    }}
                    onBlur={(event, editor) => {
                      console.log("Blur.", editor);
                    }}
                    onFocus={(event, editor) => {
                      console.log("Focus.", editor);
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid item direction="vertical" spacing={3} xs={12}>
            <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
              <Typography variant="p">Comment (Traditional Chinese)</Typography>
            </Box>
            <Grid item xs={12}>
              <Controller
                name="localizations.tc.comment"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <CKEditor
                    editor={Editor}
                    config={editorConfiguration}
                    data={field.value}
                    // disabled={disabled}
                    onReady={(editor) => {
                      // You can store the "editor" and use when it is needed.
                      console.log("Editor is ready to use!", editor);
                      // editor.setData(initialValues.terms.valueEn);
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      field.onChange(data);
                      // console.log({ event, editor, data });
                    }}
                    onBlur={(event, editor) => {
                      console.log("Blur.", editor);
                    }}
                    onFocus={(event, editor) => {
                      console.log("Focus.", editor);
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid item xs={4}>
            <Controller
              control={control}
              name="status"
              render={({
                field: { value, onChange, ...rest },
                fieldState: { error },
              }) => (
                <ToggleButtonGroup
                  {...rest}
                  value={value}
                  onChange={(event, newFormats) => {
                    if (newFormats !== null) {
                      onChange(newFormats);
                    }
                  }}
                  exclusive
                  aria-label="Status"
                  className={classes.input}
                >
                  <ToggleButton
                    value={"ACTIVE"}
                    aria-label="Active"
                    style={{ width: "50%" }}
                  >
                    Active
                  </ToggleButton>
                  <ToggleButton
                    value={"INACTIVE"}
                    aria-label="Inactive"
                    style={{ width: "50%" }}
                  >
                    Inactive
                  </ToggleButton>
                </ToggleButtonGroup>
              )}
            />
          </Grid>
          <Grid container xs={12}>
            <div className={classes.buttonGroup}>
              <Button
                type="submit"
                variant="contained"
                disableElevation
                style={{
                  color: "white",
                  background: "#306F9D",
                  marginRight: "5px",
                  padding: "9px 16px",
                }}
              >
                {id ? "Save Changes" : "Create"}
              </Button>
              {id && (
                <Button
                  variant="contained"
                  disableElevation
                  style={{
                    color: "white",
                    background: "#962013",
                    padding: "9px 16px",
                  }}
                  onClick={() => {deleteAward(id)}}
                >
                  Delete
                </Button>
              )}
            </div>
          </Grid>
        </Grid>
      </form>
    </div>
  );
}
